<template>
  <div class="sys-org-page main-layout">
    <CCollapseItem>
      <template slot="title-left"> 组织机构 </template>
      <template slot="body">
        <c-search
          v-model="pageParams"
          :searchItems="searchItems"
          @reset="refresh"
          @search="pageGet(true)"
        >
        </c-search>
      </template>
    </CCollapseItem>
    <el-card class="org-container box-bottom">
      <div class="org-card">
        <el-card class="box-tree">
          <div class="div-scroll">
            <el-tree
              :data="treeData"
              :props="defaultProps"
              @node-click="handleNodeClick"
            ></el-tree>
            <!-- :expand-on-click-node="false" 设置点击节点时不展开收缩节点 -->
          </div>
        </el-card>
        <el-card class="box-table">
          <div slot="header" class="btn-group">
            <!-- 操作按钮 -->
            <div class="btn-left">
              <div class="opt-btn" title="新增" @click="goto('')">
                <i class="iconfont icon-add"></i>
              </div>
              <div class="opt-btn" title="批量删除" @click="handleDelBatch">
                <i class="iconfont icon-batch-delete"></i>
              </div>
            </div>
            <!-- 右侧操作按钮 -->
            <table-btns
              :tableColumns="tableColumns"
              @tableColumnsChange="tableColumnsChange"
              @refresh="pageGet(true)"
            ></table-btns>
          </div>
            <c-table
              :data="pageData"
              :index="true"
              :tableColumns="tableColumns"
              :pagination="pageParams"
              @change="pageGet"
              @selectionChange="selectionChange"
              @edit="goto"
              @delete="pageDel"
              v-loading="pageLoading"
            >
            </c-table>
        </el-card>
      </div>
    </el-card>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import Configs from "./data/org";
import { mapState } from "vuex";
let mPage = MPage({
  pagePath: "/account/sys/org/list",
  pageDelPath: "/account/sys/org",
  pageDelsPath: "/account/sys/org/delBatch",
});
export default {
  mixins: [mPage],
  data() {
    let { searchItems, tableColumns } = Configs(this);
    return {
      isFold: false,
      searchItems,
      tableColumns,
      idList: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      treeData: [],
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE"]),
  },
  created() {
    this.getTreeData();
  },
  mounted() {},
  methods: {
    goto(data) {
      let id = data.id;
      if (id) {
        id = id == '#root' ? 'root' : id;
        this.$router.push("/sys/orgEdit/" + id);
      } else {
        this.$router.push("/sys/orgAdd");
      }
    },
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.id);
        });
        this.idList = idList;
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
      // 刷新组织机构树
      this.getTreeData();
    },
    refresh() {
      this.pageParams = {};
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    // 点击树节点
    handleNodeClick(data) {
      console.log(data);
      this.pageParams.parentId = data.id;
      this.pageGet(true);
    },
    // 获取树节点数据
    getTreeData() {
      this.$http.get("/account/sys/org/getOrgTree").then((res) => {
        console.log(res);
        if (res.code == this.SUCCESS_CODE) {
          this.treeData = res.data[0].children;
        }
      });
    },
  },
};
</script>
